import { render, staticRenderFns } from "./SignTime.vue?vue&type=template&id=081b058f&scoped=true"
import script from "./SignTime.vue?vue&type=script&lang=js"
export * from "./SignTime.vue?vue&type=script&lang=js"
import style0 from "./SignTime.vue?vue&type=style&index=0&id=081b058f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b058f",
  null
  
)

export default component.exports